<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Arqueo Caja</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Arqueo Caja</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-xl-8 col-lg-12">
                <app-lista-arqueo label="Movimientos" [isLoading]="isLoading"></app-lista-arqueo>
            </div>
            <div class="col-xl-4 col-lg-12">
                <app-detalle-arqueo [showHeader]="false" [showFooter]="false" (updateData)="ObtieneTotalEfectivo($event)"></app-detalle-arqueo>
                <hr>
                <div class="row  justify-content-around">
                    <div class="col-6">
                        <app-modal-movimiento label="Retiro Caja" icon="fas fa-file-invoice-dollar"
                            cssClass="btn btn-lg btn-block btn-info" idMovimiento="4"
                            (updateData)="registraMovimiento($event)"></app-modal-movimiento>
                    </div>
                    <div class="col-6">
                        <app-modal-movimiento label="Ingreso Caja" icon="fas fa-file-invoice-dollar"
                            cssClass="btn btn-lg btn-block btn-info" idMovimiento="3"
                            (updateData)="registraMovimiento($event)"></app-modal-movimiento>
                    </div>
                </div>
                <hr>
                <div class="row  justify-content-around">
                    <div class="col-6">
                        <app-modal-movimiento label="Apertura Caja" icon="fas fa-cash-register"
                            cssClass="btn btn-lg btn-block btn-success" idMovimiento="1" labelMonto="Monto Apertura"
                            (updateData)="registraMovimiento($event)"></app-modal-movimiento>
                    </div>
                    <div class="col-6">
                        <app-modal-movimiento label="Cerrar Caja" icon="fas fa-cash-register"
                            cssClass="btn btn-lg btn-block btn-danger" idMovimiento="2" labelMonto="Saldo Proxima Apertura"
                            (updateData)="registraMovimiento($event)"></app-modal-movimiento>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>